//multi_select_field_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { visibleWhen: Object }

  connect() {
    this.boundEvaluateVisibility = this.evaluateVisibility.bind(this);
    document.addEventListener("field:changed", this.boundEvaluateVisibility);
    this.evaluateVisibility(); // initial check
    console.log("Multi Select Field Controller connected 2");
  }

  disconnect() {
    document.removeEventListener("field:changed", this.boundEvaluateVisibility);
  }

  evaluateVisibility(event = null) {
    console.log("Evaluating visibility for", this.element);
    const dependencies = this.visibleWhenValue || {};

    if (!Object.keys(dependencies).length) return;

    // Collect current field values from event or document
    let currentValues = {};
    if (event) {
      currentValues[event.detail.key] = event.detail.value;
    } else {
      // fallback to DOM scanning
      Object.keys(dependencies).forEach(key => {
        const input = document.querySelector(`[name$="[${key}]"]`);
        currentValues[key] = input?.value;
      });
    }

    const shouldShow = Object.entries(dependencies).every(([key, expectedValues]) => {
      return expectedValues.includes(currentValues[key]);
    });

    shouldShow ? this.show() : this.hide();
  }

  show() {
    this.element.classList.remove("d-none");
    requestAnimationFrame(() => this.element.classList.add("fade", "show"));
  }

  hide() {
    this.element.classList.remove("show");
    this.element.addEventListener("transitionend", () => {
      this.element.classList.add("d-none");
    }, { once: true });
  }
}
